/**
 * BookFormatterApp_v2 Definition
 */

import type { AppDefinition } from '../../types/apps';

export const BookFormatterAppDefinition: AppDefinition = {
  appId: 'book_formatter_v2',
  name: 'Book',
  description: 'Format and export manuscripts for KDP publishing',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Book',
    phosphorWeight: 'duotone',
    color: '#dc2626'
  },
  version: '2.0.0',
  entityTypes: ['BookProject'],
  component: 'BookFormatterApp_v2',
  requiresEntity: true,
  requiresProps: false,
  experimental: true,
};
